<template>
  <section class="node-section">
    <div class="node-head">
      <span class="node-title">节点管理</span>
      <span class="node-count">{{ nodeCountText }}</span>
    </div>
    <div class="node-row">
      <input
        v-model.trim="inputValue"
        type="text"
        class="node-input"
        placeholder="输入节点地址"
        autocomplete="off"
      />
      <button
        type="button"
        class="btn-gold"
        :disabled="txPending"
        @click="onAdd"
      >
        添加
      </button>
      <button
        type="button"
        class="btn-gold"
        :disabled="txPending"
        @click="onRemove"
      >
        删除
      </button>
    </div>
  </section>
</template>

<script>
import { Toast } from "vant";
import { addNode, removeNode } from "@/contract";
import {
  normalizeNodeAddressInput,
  fetchNodeAddressList,
} from "../helpers/adminNodeChain.js";

export default {
  name: "AdminNodeSection",
  data() {
    return {
      inputValue: "",
      nodeAddresses: [],
      listLoading: false,
      txPending: false,
    };
  },
  computed: {
    nodeCountText() {
      if (this.listLoading) return "加载中…";
      return `${this.nodeAddresses.length}个节点`;
    },
  },
  mounted() {
    this.refreshList();
  },
  methods: {
    async refreshList() {
      this.listLoading = true;
      try {
        this.nodeAddresses = await fetchNodeAddressList();
      } catch (e) {
        console.warn("[AdminNodeSection] fetchNodeAddressList", e);
        this.nodeAddresses = [];
        Toast.fail("节点列表读取失败");
      } finally {
        this.listLoading = false;
      }
    },
    async onAdd() {
      const addr = normalizeNodeAddressInput(this.inputValue);
      if (!addr) {
        Toast("请输入合法节点地址");
        return;
      }
      this.txPending = true;
      try {
        await addNode(addr);
        Toast.success("添加节点已上链");
        this.inputValue = "";
        await this.refreshList();
      } catch (err) {
        Toast.fail(this.txErrMessage(err, "添加失败"));
      } finally {
        this.txPending = false;
      }
    },
    async onRemove() {
      const addr = normalizeNodeAddressInput(this.inputValue);
      if (!addr) {
        Toast("请输入要删除的合法节点地址");
        return;
      }
      this.txPending = true;
      try {
        await removeNode(addr);
        Toast.success("已移除节点");
        this.inputValue = "";
        await this.refreshList();
      } catch (err) {
        Toast.fail("删除失败");
      } finally {
        this.txPending = false;
      }
    },
    txErrMessage(err, fallback) {
      const m = err?.message || err?.msg;
      if (typeof m === "string" && m.trim()) return m;
      return fallback;
    },
  },
};
</script>

<style lang="scss" scoped>
.node-section {
  margin-bottom: 48px;
}

.node-head {
  display: flex;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.node-title {
  font-size: 32px;
  font-weight: 600;
  color: #1a1a1a;
}

.node-count {
  font-size: 24px;
  color: #666;
}

.node-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.node-input {
  flex: 1;
  min-width: 0;
  height: 72px;
  padding: 0 20px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: #fff;
  font-size: 24px;
  color: #333;
  box-sizing: border-box;
}

.btn-gold {
  flex-shrink: 0;
  min-width: 100px;
  height: 72px;
  padding: 0 16px;
  border: none;
  border-radius: 8px;
  background: #e5c486;
  color: #1a1a1a;
  font-size: 24px;
  font-weight: 500;
  cursor: pointer;
}

.btn-gold:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-gold:active:not(:disabled) {
  filter: brightness(0.97);
}
</style>
